var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tooltip wishlist",attrs:{"aria-label":"dodaj u listu želja","data-tooltip":"Dodaj u listu želja"},on:{"click":_vm.addToWishList}},[_c('heart-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }